import { render, staticRenderFns } from "./LessonVideo.vue?vue&type=template&id=18f1bda6&"
import script from "./LessonVideo.vue?vue&type=script&lang=js&"
export * from "./LessonVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports